'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';


export const navigationBarLinkProps = {
  className: "NavigationBar__link",
  activeClassName: "NavigationBar__link_active",
  activatedClassName: "NavigationBar__link_activated",
};

export function NavigationBarView(props) {
  return (
    <div
      className={classNames("NavigationBar", props.className)}
    >
      {props.children}
    </div>
  );
}

NavigationBarView.propTypes = {
  className: T.string,
  children: T.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/views/NavigationBar/NavigationBarView.js